import { render } from "./ForgotPassword.vue?vue&type=template&id=7162603f&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "@/styles/ForgotPassword.css?vue&type=style&index=0&id=7162603f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7162603f"]])

export default __exports__